import { Component } from '@angular/core';
import {GenericChartModel} from '../generic-chart.model';
import {element} from 'protractor';

@Component({
  selector: 'cmp-chart-amchart-line',
  template: `<cmp-chart-amchart  [loading]="loading"
                    [chartData]="buildData"
                    [noResults]="noResults || {}">
</cmp-chart-amchart>


`,
  styles: [``]
})
export class ChartAmchartLineComponent extends GenericChartModel {
  constructor() {
    super();
  }

  getData(seriesArg) {
    const series = JSON.parse(JSON.stringify(seriesArg));
    const chartData = [];
    const graphData = [];
    const legendData = [];
    let valueAxisLogarithmic = null;

    const values = series.map(superElement => {
      return superElement.values.map(elementChart => {
        return elementChart.value;
      });
    });
    const mergedValues = [].concat.apply([], values); 
    valueAxisLogarithmic = this.configData.customLogarithmic ? GenericChartModel.isLogarithmic(mergedValues) : false;
    let isText = false;
    series.forEach((superElementChart, j) => {
      const valueField = superElementChart.name ? superElementChart.name : j.toString();
      if (j === 0) {
        isText = superElementChart.name ? true : false;
      }
      legendData.push({
        title: valueField, color: valueField && this.configData.colorGraph[valueField] ?
          this.configData.colorGraph[valueField] :
          this.graphData.CSS_COLOR_CORPORATIVE[j % this.graphData.CSS_COLOR_CORPORATIVE.length]
      });
      superElementChart.values.forEach((elementChart) => {
        const rd = chartData.findIndex(
          d => d[this.configData.categoryField] === (this.configData.isTimeStamp ?
            GenericChartModel.getHumanReadableDateYearMonthDay(elementChart.key) :
            elementChart.key)
        );
        if ((rd || rd === 0) && chartData[rd]) {
          chartData[rd][valueField] = valueAxisLogarithmic ?
            (elementChart.value === 0 ? 1 : elementChart.value.toFixed(1)) :
            elementChart.value.toFixed(1);
        } else {
          const tempObj: any = {};
          tempObj[this.configData.categoryField] = this.configData.isTimeStamp ?
            GenericChartModel.getHumanReadableDateYearMonthDay(elementChart.key) :
            elementChart.key;
          tempObj[valueField] = valueAxisLogarithmic ?
            (elementChart.value === 0 ? 1 : elementChart.value.toFixed(1)) :
            elementChart.value.toFixed(1);
          chartData.push(tempObj);
        }
      });

      const tempGraphObject = <any>{
        id: 'g' + valueField,
        lineColor: valueField && this.configData.colorGraph[valueField] ?
          this.configData.colorGraph[valueField] :
          this.graphData.CSS_COLOR_CORPORATIVE[j % this.graphData.CSS_COLOR_CORPORATIVE.length],
        title: valueField,
        valueField: valueField
      };

      if (this.configData.bulletConfig) {
        if (this.configData.bulletConfig.bullet) {
          tempGraphObject.bullet = this.configData.bulletConfig.bullet;
        }
        if (this.configData.bulletConfig.bulletBorderAlpha != null) {
          tempGraphObject.bulletBorderAlpha = this.configData.bulletConfig.bulletBorderAlpha;
        }
        if (this.configData.bulletConfig.bulletSize != null) {
          tempGraphObject.bulletSize = this.configData.bulletConfig.bulletSize;
        }
        if (this.configData.bulletConfig.bulletAlpha != null) {
          tempGraphObject.bulletAlpha = this.configData.bulletConfig.bulletAlpha;
        }
      }

      if (this.configData.lineConfig) {
        if (this.configData.lineConfig.lineThickness != null) {
          tempGraphObject.lineThickness = this.configData.lineConfig.lineThickness;
        }
        if (this.configData.lineConfig.fillAlphas != null) {
          tempGraphObject.fillAlphas = this.configData.lineConfig.fillAlphas;
        }
        if (this.configData.lineConfig.lineAlpha != null) {
          tempGraphObject.lineAlpha = this.configData.lineConfig.lineAlpha;
        }
        if (this.configData.lineConfig.lineColor != null) {
          tempGraphObject.lineColor = this.configData.lineConfig.lineColor;
        }
        if (this.configData.lineConfig.useLineColorForBulletBorder != null) {
          tempGraphObject.useLineColorForBulletBorder = this.configData.lineConfig.useLineColorForBulletBorder;
        }
      }

      if (this.configData.balloonText && this.configData.balloonCustomFunction) {
        tempGraphObject.balloonFunction = (item, graph) => {
          return (
            isText ?
              `<span style='font-family: helvetica' style='font-size:12px;'>${item.category} ${graph.title}: <b>${this.getConverter(
              item.values.value
            )}</span></b>` :
              `<span style='font-family: helvetica' style='font-size:12px;'>${item.category} <b>${this.getConverter(
            item.values.value
          )}</span></b>`);
        };
      } else if (this.configData.balloonText) {
        tempGraphObject.balloonText = isText ?
          `<span style='font-family: helvetica' style='font-size:12px;'>[[category]] [[title]]: <b>[[value]]</b></span>` :
          `<span style='font-family: helvetica' style='font-size:12px;'>[[category]]  <b>[[value]]</b></span>`;
      }else if (this.configData.balloonCustomFunction) {
        tempGraphObject.balloonFunction = (item, graph) => {
          return `<span style='font-family: helvetica' style='font-size:12px;'>${this.getConverter(
            item.values.value
          )}</span>`;
        };
      }

      graphData.push(tempGraphObject);
    });

    if (this.configData.isLegend) {
      this.legendData = {
        align: 'left',
        position: 'bottom',
        markerSize: 10,
        marginTop: 20,
        valueWidth: 120,
        valueText: ``,
      };
      if (legendData && legendData.length > 0 && this.configData.isLegend) {
        this.legendData.data = legendData;
      }
    }
    if (this.configData.isSortable) {
      GenericChartModel.sortScore(chartData, this.configData.categoryField);
    }
    this.chartData = { data: chartData, graph: graphData};
  }

  parseData(chart, id = null, dataSet = [], index = null) {
    try {
      const yValues = chart['graphset'][0]['series'];
      const xValues = chart['graphset'][0]['scaleX']['values'];
      const chartType = chart['graphset'][0]['type'];
      const basicData = dataSet.find(chartDataSet => {
        return chartDataSet.id === id;
      });
      const name = basicData ? basicData.title : '';

      const series = yValues.map((superElement, j) => {
        const valueField = superElement.text ? superElement.text : j.toString();
        const tempvalueArray = superElement.values.map((chartElement, i) => {
          return {
            key : xValues[i],
            value: chartElement
          };
        });
        return {
          name: valueField,
          values: tempvalueArray
        };
      });

      const graph = {
        title: basicData ? basicData.title : '',
        xlabel: '',
        ylabel: '',
        type: chartType,
        series
      };
      return { name, graph, id, index };
    } catch (error) {
      return { id, index };
    }
  }
}
